import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/5c64f483/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`We are currently reassessing how we maintain the component status page and so for the meantime, we’ve removed the status table for individual components.`}</p>
    <p>{`All Carbon components are stable and approved for production in React. For the latest component updates in other frameworks, please refer to the respective repository’s changelog.`}</p>
    <p>{`We want to make sure that this page includes the information you need to make decisions and that it’s always up-to-date. Please `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-website/issues/961"
      }}>{`let us know`}</a>{` if there is any information in particular you would like to see surfaced here.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      